import request from '@/utils/request'

export function getRoles() {
  return request({
    url: '/api/roles',
    method: 'get'
  })
}

export function addRole(data) {
  return request({
    url: '/api/role',
    method: 'post',
    data
  })
}

export function updateRole(id, data) {
  return request({
    url: `/api/role/${id}`,
    method: 'put',
    data
  })
}

export function deleteRole(id) {
  return request({
    url: `/api/role/${id}`,
    method: 'delete'
  })
}

export function deleteBrandS(id) {
  return request({
    url: `/ocs-auth/brand/manage/delete/${id}`,
    method: 'post'
  })
}

export function getBrandSaves(operType,data) {
  return request({
    url: `/ocs-auth/brand/manage/${operType}`,
    method: 'post',
    data
  })
}

// 独立授权
export function getBrandLists(operType) {
  return request({
    url: `/ocs-auth/menu/select/brand/${operType}`,
    method: 'get',
    data
  })
}

// export function getBrandSaves(operType,data) {
//   return request({
//     url: `/brand/manage/${operType}`,
//     method: 'post',
//     data
//   })
// }

// 角色管理接口
export function getRoleListSel(data) {
  return request({
    url: `/ocs-auth/role/select`,
    method: 'post',
    data
  })
}

// 新增角色接口
export function getRoleType(operType,data) {
  return request({
    url: `/ocs-auth/role/${operType}`,
    method: 'post',
    data
  })
}

// 角色删除
export function deleteRoleDel(id) {
  return request({
    url: `/ocs-auth/role/delete/${id}`,
    method: 'get'
  })
}

// 角色权限接口
export function getRoleMenuList(brandId,roleId) {
  return request({
    url: `/ocs-auth/role/menuList/${brandId}/${roleId}`,
    method: 'get',
  })
}

// 角色管理显示可分配人员&已选人员
export function getRoleUserRoleList(data) {
  return request({
    url: `/ocs-auth/role/roleUserList`,
    method: 'post',
    data
  })
}

// 更新角色的用户
export function getRoleUpdateUserList(data) {
  return request({
    url: `/ocs-auth/role/update/roleUserList`,
    method: 'post',
    data
  })
}